import React, {useState} from 'react';
// import './Menu.css';
// import MenuOptions from "./MenuOptions/MenuOptions";
import {isMobile} from "react-device-detect";
import MobileMenu from "./MobileMenu/MobileMenu";
import DesktopMenu from "./DesktopMenu/DesktopMenu";

const Menu = () => {

    // const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
    //
    // const openMenuModal = () => {
    //     setIsMenuModalOpen(true);
    // }
    //
    // const closeMenuModal = () => {
    //     setIsMenuModalOpen(false);
    // }

    // return (
        // <div className={'menu-choose'}>
            {/*{!isMenuModalOpen ?*/}
            {/*    <svg x="0px" y="0px" viewBox="2.5 2.5 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={openMenuModal}>*/}
            {/*        <path d="M4 18L20 18" stroke="#555555" stroke-width="2" stroke-linecap="round"/>*/}
            {/*        <path d="M4 12L20 12" stroke="#555555" stroke-width="2" stroke-linecap="round"/>*/}
            {/*        <path d="M4 6L20 6" stroke="#555555" stroke-width="2" stroke-linecap="round"/>*/}
            {/*    </svg>*/}
            {/*:*/}
            {/*    <svg x="0px" y="0px" viewBox="2.5 2.5 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={closeMenuModal}>*/}
            {/*        <path d="M5 5L19 19M5 19L19 5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>*/}
            {/*    </svg>*/}
            {/*}*/}

            {/*<MenuOptions*/}
            {/*    isOpen={isMenuModalOpen}*/}
            {/*    onRequestClose={setIsMenuModalOpen}*/}
            {/*/>*/}


        // </div>
    // );

    if (isMobile) {
        return (
            <MobileMenu />
        );
    } else {
        return (
            <DesktopMenu />
        );
    }
};

export default Menu;